import type { App } from 'vue';

// Font Awesome Pro webfont (required for Quasar icon set). Requires @fortawesome/fontawesome-pro and npm registry auth.
//
// PRODUCT-26110: FA must be imported BEFORE quasar.scss. Quasar renders its own icons
// with both classes (e.g. `i.fal.q-icon`), and FA's `.fa*, .fal { display: var(--fa-display,
// inline-block) }` ties with Quasar's `.q-icon { display: inline-flex }` on specificity --
// so whichever sheet lands later wins. Vite emits these in import order, which put FA
// last and flattened Quasar's flex-centred icons to inline-block; the webpack build this
// replaced emitted Quasar last, which is why dev centres them correctly.
import '@fortawesome/fontawesome-pro/css/fontawesome.min.css';
import '@fortawesome/fontawesome-pro/css/light.min.css';
import './quasar.scss';
import {
    Quasar,
    ClosePopup,
    QIcon,
    QList,
    QItem,
    QItemLabel,
    QSelect,
    QChip,
    QExpansionItem,
    QVirtualScroll,
    QSplitter,
    QItemSection,
} from 'quasar';
import iconSet from 'quasar/icon-set/fontawesome-v6-pro';

// Use angle-down for dropdown (e.g. QSelect) instead of default caret-down
iconSet.arrow.dropdown = 'fal fa-angle-down';

// PRODUCT-26110 Phase 2B2 Task 1 (Quasar 2): Quasar 2 is Vue-3-native -- its
// `install(app, opts)` calls real Vue 3 App APIs (`app.directive()`,
// `app.config.globalProperties`, a reactive `$q` context, etc.) that the
// `@vue/compat` global singleton's `Vue.use()` shim (the Quasar 1-era approach
// this file used to take) cannot satisfy. So this now exports a plain installer
// function instead of calling `Vue.use()` at module-evaluation time; the caller
// (main.ts) threads it through `appPlugins` (see types/Application.ts) so it runs
// against the real `createApp()` instance in Application.ts's `mount()`, the same
// place `app.use(store)`/`app.use(router)` already run.
//
// Only the handful of components actually used in this app's .vue files are
// registered explicitly (Quasar 2 supports auto-registering the entire component
// set instead, but that defeats webpack tree-shaking here -- keeping the Quasar 1
// era's explicit list). `ClosePopup` is added because `v-close-popup` is used
// directly in template markup (see task-2 component migration) and Quasar 2 no
// longer auto-registers directives referenced this way outside Quasar CLI's
// auto-import build step.
export function installQuasar(app: App): void {
    app.use(Quasar, {
        config: {},
        iconSet,
        components: {
            QIcon,
            QList,
            QItem,
            QItemLabel,
            QSelect,
            QChip,
            QExpansionItem,
            QVirtualScroll,
            QSplitter,
            QItemSection,
        },
        directives: {
            ClosePopup,
        },
        plugins: {
        },
    });
}
